export default "__VITE_ASSET__DXs0FOWQ__"